// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rim-repair-card[data-v-8b9489d8]{position:relative;height:100%}.rim-repair-card-text[data-v-8b9489d8]{padding-bottom:0}.rim-repair-card-actions[data-v-8b9489d8]{position:absolute;bottom:0}.phone[data-v-8b9489d8]{font-size:14px!important}.phone-row[data-v-8b9489d8]{font-weight:300}", ""]);
// Exports
module.exports = exports;
